export const getApiUrl = (isBaseUrlOnly = false): string => {
  let url = "";
  if (!isBaseUrlOnly && __SERVER__ && process.env.BASE_SERVICE_URL_SERVER) {
    url = process.env.BASE_SERVICE_URL_SERVER;
  } else if (process.env.BASE_SERVICE_URL) {
    url = process.env.BASE_SERVICE_URL;
  } else if (__DEV__) {
    url = "https://api-local.staging-amber.com";
  } else {
    url = "https://api.staging-amber.com";
  }
  // strip trailing slash
  return url.endsWith("/") ? url.slice(0, -1) : url;
};

export default {
  HOST: "0.0.0.0",
  PORT: process.env.LOCAL_PORT || (__DEV__ ? 3000 : 8080),
  API_URL: getApiUrl(),
  CMS_API_URL: process.env.CMS_API_URL || "https://cms.staging-amber.com",
  IS_WHITELABEL_APP: process.env.IS_WHITELABEL_APP === "true" || false,
  IS_CHINA_APP: process.env.BEANSTALK_APP_NAME === "webapp-hk",
  // TEMPORARY (SEO): strip /blog* links from /places* content. On by default; build with HIDE_BLOG_LINKS=false to disable.
  HIDE_BLOG_LINKS: process.env.HIDE_BLOG_LINKS !== "false",
  // SEO (PLG-3406): drop/unwrap links to noindexed search pages. On by default; build with HIDE_NOINDEX_LINKS=false to disable.
  HIDE_NOINDEX_LINKS: process.env.HIDE_NOINDEX_LINKS !== "false",
  IS_CHINA_ARTIFACT: process.env.ARTIFACT_TAG?.includes("cn") || false,
  IMAGE_STATIC_ASSETS_APP_PATH: `${__ASSETS_BASE_URL__}images/app`,
  IMAGE_STATIC_ASSETS_PAGE_PATH: `${__ASSETS_BASE_URL__}images/pages`,
  IMAGE_STATIC_ASSETS_COMPONENTS_PATH: `${__ASSETS_BASE_URL__}images/components`,
  IMAGE_STATIC_URL:
    process.env.IMAGE_STATIC_ASSETS_URL || "https://prod-static-assets.amberstudent.com",
  IMAGE_ASSETS_URL: process.env.IMAGE_ASSETS_URL || "https://prod-assets.amberstudent.com",
  IMAGE_ASSETS_DEV_URL: "https://assets.dev-amber.com",
  WEBFLOW_ASSET_URL: process.env.WEBFLOW_ASSET_URL || "https://webflow-assets.amberstudent.com",
  BLOG_ASSET_URL: "https://webflow-amber-prod.gumlet.io",
  WECHAT_APP_ID: "wx3cea94640d248d02",
  WEB_SERVICE_URL: process.env.WEB_SERVICE_URL || "https://staging-amber.com/",
  WEB_SERVICE_HOST: process.env.WEB_SERVICE_HOST || "localhost",
  CHINA_STATIC_ASSETS_URL: "https://assets.amberstudent.cn",
  WEB_SERVICE_HOST_CHINA: "amberstudent.cn",
  MINI_PROGRAM_WEB_SERVICE_HOT: "amberstudent.cn",
  BEANSTALK_APP_NAME: process.env.BEANSTALK_APP_NAME || "webapp",
  IS_CASHBACK_PROCESSING_ENABLED: process.env.IS_CASHBACK_PROCESSING_ENABLED || "true",
  ZENDESK_IS_VISIBLE: "false",
  CLARITY_TOKEN: "nm39l5m079",
  GLOBAL_WEB_URL: process.env.GLOBAL_WEB_URL || "https://amberstudent.com",
  CHINA_WEB_URL: process.env.CHINA_WEB_URL || "https://amberstudent.cn",
  GOOGLE_CLIENT_ID:
    process.env.GOOGLE_CLIENT_ID ||
    "1092885862627-vnguq91il7pefnt5u7d08c5680p1ql72.apps.googleusercontent.com",
  FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID || "1158664500856575",
  APPLE_CLIENT_ID: process.env.APPLE_CLIENT_ID || "sso.amber",
  isProduction: process.env.WEB_SERVICE_HOST === "amberstudent.com",
  // Never put these in amber-infra BUILD.Secrets or a build arg: DefinePlugin
  // would inline them into every visitor's JS (ENG-921).
  TOLGEE_APIKEY_PROD: process.env.TOLGEE_APIKEY_PROD,
  TOLGEE_APIKEY_STAGING: process.env.TOLGEE_APIKEY_STAGING,
  POSTHOG_API_KEY:
    process.env.POSTHOG_API_KEY ||
    (process.env.BEANSTALK_APP_NAME === "webapp-hk"
      ? "phc_8VZ7PuYh5f0bco06Y8O3aBA1xy6Z8qD6GUL5Dq0TCQd"
      : "phc_vCbyBuK48hfdALfigRCiaLunweodmY66WAput3j3zNhM"),
  ZENDESK_URL:
    process.env.BEANSTALK_APP_NAME === "webapp-hk"
      ? process.env.ZENDESK_CHINA_URL
      : process.env.ZENDESK_URL ||
        `https://static.zdassets.com/ekr/snippet.js?key=c3f7d630-ae75-4536-80c2-73d964f8d217`,
  snapchat_event_id: process.env.SNAPCHAT_EVENT_ID || "662bcf3e-ddc1-4b2c-88fc-9ba6cb341f17",
  COMMUNICATION_SERVICE_URL:
    process.env.WEB_SERVICE_HOST === "amberstudent.com"
      ? "https://comms-service.amberstudent.com"
      : "https://comms-service.staging-amber.com",
  SIMILAR_PROPERTIES_URL: process.env.SIMILAR_PROPERTIES_URL || "https://data-api.amberstudent.com",
  CONTENT_SECURITY_POLICY_SCRIPTS:
    "https://maps.googleapis.com https://cdnjs.cloudflare.com https://cdn-static-assets.amberstudent.com https://ind-widget.freshworks.com https://res.cloudinary.com https://widget.cloudinary.com https://upload-widget.cloudinary.com https://www.googletagmanager.com https://connect.facebook.net https://bat.bing.com https://analytics.tiktok.com https://browser.sentry-cdn.com https://fxgate.baidu.com https://www.clarity.ms https://analytics.oceanengine.com https://static.meiqia.com https://*.meiqia.com https://www.google.com https://www.gstatic.com https://api.mapbox.com https://appleid.cdn-apple.com https://accounts.google.com https://apis.google.com https://www.google-analytics.com https://static.zdassets.com https://hm.baidu.com https://sc-static.net https://checkout.stripe.com https://js.stripe.com https://scripts.clarity.ms https://cdn.growthbook.io https://widget.trustpilot.com https://static.zdassets.com https://ekr.zdassets.com https://*.zendesk.com https://*.zopim.com https://api.eu-1.smooch.io https://my.matterport.com https://tr.snapchat.com/ https://assets.amberstudent.cn https://static-assets.amberstudent.com https://oss-assets.amberstudent.cn https://www.redditstatic.com https://amberstudent.keka.com https://tracking.amberstudent.cn https://posthog.amberstudent.com https://public.flourish.studio https://*.meiqiacloud.com",
  growthbook: {
    apiHost: process.env.GROWTHBOOK_API_HOST || "https://cdn.growthbook.io",
    clientKey:
      process.env.GROWTHBOOK_CLIENT_KEY ||
      (process.env.WEB_SERVICE_HOST === "amberstudent.com"
        ? "sdk-ClrKZu28982Rd6Vj"
        : "sdk-vKygo4HgWlW1qWlu"),
  },
  apiParams: !__CLIENT__
    ? {
        timeout: process.env.WEB_SERVICE_HOST === "amberstudent.com" ? 60000 : 100000,
      }
    : {
        timeout: 60000,
      },
  RECAPTCHA_SITE_KEY_V2:
    process.env.WEB_SERVICE_HOST === "amberstudent.com"
      ? "6LeXkUUqAAAAAJQnHY_CYczOGWBPFyziAW2I9Pvl"
      : "6LebXTUqAAAAAPcpHS6JpJG66y5dzcczKVtt7LQU",
  RECAPTCHA_SITE_KEY_V3:
    process.env.WEB_SERVICE_HOST === "amberstudent.com"
      ? "6LdSARAqAAAAAHoUwWW7WHAamVDlFmjk9ZjeVG6M"
      : "6LfPoA0qAAAAAEwRyhR8w1h3o9P48YT0oaKoiZKr",
  STRIPE_API_KEY:
    process.env.WEB_SERVICE_HOST === "amberstudent.com"
      ? "pk_live_QsmxyqOenm5bd7BLRhsm4GkA"
      : "pk_test_EktKqD9nXXqsobEkpHjsBawR",
  UNIKIT_ASSET_URL:
    process.env.UNIKIT_ASSET_URL || "https://webflow-amber-prod.gumlet.io/amber-unikit/",
  UNIKIT_PAYMENTS_RESOURCE: process.env.UNIKIT_PAYMENTS_RESOURCE || "amber_plus_payments",
  UNIKIT_PAYMENTS_ROOT_KEY: process.env.UNIKIT_PAYMENTS_ROOT_KEY || "amber_plus_payment",
  UNIKIT_PAYMENTS_UPDATE_PATH: process.env.UNIKIT_PAYMENTS_UPDATE_PATH || "update_details",
  UNIKIT_CHECKOUT_EMAIL:
    process.env.UNIKIT_CHECKOUT_EMAIL || "unikit.checkout.placeholder@amberstudent.com",
  UNIKIT_SKIP_CART_VALIDATION: process.env.UNIKIT_SKIP_CART_VALIDATION === "true" || false,
  /** Partner (Aelixar) KYC login destination; overridden per-order when the API returns one. */
  ESIM_KYC_LOGIN_URL: process.env.ESIM_KYC_LOGIN_URL || "https://amber.aelixar.com/uk/login",
  REDIS_MODE: process.env.REDIS_MODE || "standalone",
  MAPBOX_ACCESS_TOKEN:
    process.env.MAPBOX_ACCESS_TOKEN ||
    // eslint-disable-next-line no-nested-ternary
    (process.env.WEB_SERVICE_HOST === "amberstudent.com"
      ? process.env.BEANSTALK_APP_NAME === "webapp-hk"
        ? "pk.eyJ1IjoiYW1iZXJzdHVkZW50IiwiYSI6ImNtZDRlanBqNDBlZnAyaXNkamh0MzhrMmIifQ.OhJhIlkvMQLfZOHforzMSA"
        : "pk.eyJ1IjoiYW1iZXJzdHVkZW50IiwiYSI6ImNtOG9odHZkcjAwaHgya3F4aHpkODd0c2IifQ.CwvCPHpUY9LjHA1cRK9NmA"
      : "pk.eyJ1IjoicHJvZHVjdC10b29scyIsImEiOiJjbTJscmphZGQwZzFhMmxzMWRqamtoOG5yIn0.2vwb8CIhD0TpsuzUHibdkw"),
  SHOW_MAPBOX_GLOBAL: true,
  TOLGEE_ENDPOINT: process.env.TOLGEE_ENDPOINT || "https://tolgee.amberstudent.com",
  // Kill switch for all Tolgee API interactions.
  // When false, translations are served exclusively from the static file (public/locales/translations.json).
  // Must compare to "true" — env vars are strings, so `|| false` would treat "false" as truthy.
  ENABLE_TOLGEE: process.env.ENABLE_TOLGEE === "true",
};
